import { render, staticRenderFns } from "./UserOrder.vue?vue&type=template&id=6d205db4&scoped=true"
import script from "./UserOrder.vue?vue&type=script&lang=js"
export * from "./UserOrder.vue?vue&type=script&lang=js"
import style0 from "./UserOrder.vue?vue&type=style&index=0&id=6d205db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d205db4",
  null
  
)

export default component.exports